import { LoaderFunction, redirect } from "react-router-dom";
import { getSignupStep } from "@/entities/auth/signup/api/requests";

export type LoaderData<TLoaderFn extends LoaderFunction> =
  Awaited<ReturnType<TLoaderFn>> extends Response | infer D ? D : never;

export const signupLoader = (async () => {
  const token = localStorage.getItem("token");

  if (token) {
    const response = await getSignupStep(token);
    if (typeof response?.step === "number") {
      return response.step;
    } else if (response && response.step === null) {
      return redirect("/cabinet", { status: 301 });
    } else {
      // 0 - initial step
      return 0;
    }
  } else {
    // 0 - initial step
    return 0;
  }
}) satisfies LoaderFunction;
